const leaderboard = {
  bronze: [
    { userID: "1", XP: 500, streaks: 23, name: "Ben Shapiro", avatar: "bird1" },
    {
      userID: "2",
      XP: 450,
      streaks: 10,
      name: "Sarah Patterson",
      avatar: "bird4",
    },
    {
      userID: "620bada399de8f7b01d7d450",
      XP: 320,
      streaks: 6,
      name: "Test1",
      avatar: "bird3",
    },
    { userID: "3", XP: 300, streaks: 2, name: "Test 13", avatar: "bird2" },
    { userID: "4", XP: 288, streaks: 3, name: "Test 14", avatar: "bird2" },
    { userID: "5", XP: 278, streaks: 4, name: "Test 15", avatar: "bird1" },
    { userID: "6", XP: 270, streaks: 2, name: "Test 16", avatar: "bird4" },
    { userID: "7", XP: 265, streaks: 1, name: "Test 17", avatar: "bird1" },
    { userID: "8", XP: 262, streaks: 6, name: "Test 18", avatar: "bird3" },
    { userID: "9", XP: 250, streaks: 3, name: "Test 19", avatar: "bird2" },
    { userID: "10", XP: 245, streaks: 1, name: "Test 20", avatar: "bird1" },
    { userID: "11", XP: 200, streaks: 2, name: "Test 21", avatar: "bird2" },
  ],
  silver: [
    { userID: "12", XP: 850, streaks: 23, name: "Test 22", avatar: "bird2" },
    { userID: "13", XP: 800, streaks: 10, name: "Test 23", avatar: "bird1" },
    { userID: "14", XP: 700, streaks: 16, name: "Test 24", avatar: "bird3" },
  ],
  gold: [
    { userID: "15", XP: 1200, streaks: 43, name: "Test 25", avatar: "bird2" },
    { userID: "16", XP: 1005, streaks: 30, name: "Test 26", avatar: "bird2" },
    { userID: "17", XP: 995, streaks: 62, name: "Test 27", avatar: "bird2" },
  ],
};

const challenges = [
  {
    id: "100",
    name: "7 day streak for the win!",
    dateCreated: "2022-05-02T18:30:00.000+00:00",
    dateEnded: "2022-05-07T18:30:00.000+00:00",
    coinsBet: 20,
    isSelfChallenge: true,
    creatorName: "Test1",
    creator: "620bada399de8f7b01d7d450",
    participants: [{ userID: "620bada399de8f7b01d7d450", userName: "Test1" }],
    participantResults: [{ userID: "620bada399de8f7b01d7d450", result: "won" }],
    status: "completed",
    description:
      "Continue 7 days streak starting from today to double the coins bet because consistency is key!",
  },
  {
    id: "101",
    name: "Go above and beyond for the next 3 days!",
    dateCreated: "2022-05-07T18:30:00.000+00:00",
    dateEnded: "2022-05-09T18:30:00.000+00:00",
    coinsBet: 20,
    isSelfChallenge: true,
    creator: "620bada399de8f7b01d7d450",
    creatorName: "Test1",
    participants: [{ userID: "620bada399de8f7b01d7d450", userName: "Test1" }],
    participantResults: [
      { userID: "620bada399de8f7b01d7d450", result: "lost" },
    ],
    status: "completed",
    description:
      "For the next 3 days, complete the daily goal and then some more!",
  },
  {
    id: "102",
    name: "Go above and beyond for the next 10 days!",
    dateCreated: "2022-05-07T18:30:00.000+00:00",
    dateEnded: "2022-05-17T18:30:00.000+00:00",
    coinsBet: 20,
    isSelfChallenge: false,
    creator: "620bada399de8f7b01d7d450",
    creatorName: "Test1",
    participants: [
      { userID: "620bada399de8f7b01d7d450", userName: "Test1" },
      {
        userID: "61d068dd7fa3626b4b520c61",
        userName: "Megan Markle",
      },
    ],
    participantResults: [],
    status: "ongoing",
    description:
      "For the next 10 days, complete the daily goal and then some more!",
  },
  {
    id: "103",
    name: "14 day streak for the win!",
    dateCreated: "2022-05-02T18:30:00.000+00:00",
    dateEnded: "2022-05-14T18:30:00.000+00:00",
    coinsBet: 40,
    isSelfChallenge: false,
    creator: "61d068dd7fa3626b4b520c61",
    creatorName: "Megan Markle",
    participants: [
      { userID: "620bada399de8f7b01d7d450", userName: "Test1" },
      {
        userID: "61d068dd7fa3626b4b520c61",
        userName: "Megan Markle",
      },
    ],
    participantResults: [],
    status: "ongoing",
    description:
      "Continue 14 days streak starting from today to double the coins bet because consistency is key!",
  },
];

export { leaderboard, challenges };
